module.exports = __webpack_public_path__ + "static/media/4cardsequence.96a610c9.png";